import styles from "./History.module.css";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SearchHistory from "../../Components/SearchHistory/SearchHistory";
import Table from "../../Components/Table/Table";
import { fetchAllHistoryLogs } from "../../Services/Slices/getHistoryLogs";
import { formatDateUTC } from "../../Components/Helper";

interface FilterHistory {
  start_date?: string;
  end_date?: string;
  action?: string[];
  atoType?: string[];
  number?: string;
  user?: string[];
  words?: string[];
}

export default function History() {
  const dispatch = useDispatch<any>();
  const response = useSelector((state: any) => state.AllHistoryLogsSlice);
  const [backup, setBackup] = useState<FilterHistory>({});
  const [isSearched, setIsSearched] = useState(false);
  const [extracted, setExtracted] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [filters, setFilters] = useState<FilterHistory>({});
  const [tempPage, setTempPage] = useState<number | null>(null);

  const columns = [
    { title: "Ação", property: "action" },
    { title: "Arquivo", property: "archive" },
    { title: "Data", property: "event" },
    { title: "Hora", property: "hour" },
    { title: "Autor", property: "user" },
  ];

  useEffect(() => {
    const filterParams = {
      start_date: filters.start_date,
      end_date: filters.end_date,
      action: filters.action?.join(","),
      atoType: filters.atoType?.join(","),
      user: filters.user?.join(","),
    };

    dispatch(fetchAllHistoryLogs(filterParams, page.toString()));

  }, [ page, filters]);

  const handleClearFilters = () => {
    setPage(1);
    setIsSearched(false);
    setBackup({});
    setFilters({});
    dispatch(fetchAllHistoryLogs(filters, "1"));
  };

  useEffect(() => {
    if (isSearched && page !== tempPage) {
      dispatch(fetchAllHistoryLogs(backup, page.toString()));
      setTempPage(page);
    }
  }, [dispatch, isSearched, backup, page, tempPage]);

  useEffect(() => {
    if (response?.data) {
      const dataToUse = response.data.results || response.data;
      const formattedData = dataToUse
      .map((row: any) => {
        if (row.action === "Publicado") {
          const fileName = row.details?.file;
          const rawDate = fileName.split("date=")[1]?.split("---")[0];
          const [day, month, year] = rawDate.split("-");
          const isoDate = `${year}-${month}-${day}`;
          const hourPart = fileName.includes("hour=")
            ? fileName.split("hour=")[1].split("---")[0]
            : "00:00";
          const scheduledString = `${isoDate}T${hourPart}:00`;
          const scheduledDate = new Date(scheduledString);
          const now = new Date();
      
          if (scheduledDate > now) {
            return null;
          }
        }
      
        return {
          action: row.action,
          archive: cleanFile(row.details),
          event: cleanDate(row.created_at),
          hour: cleanHour(row),
          user: row.details.user,
        };
      })
        .filter((log: any) => log !== null);

      setExtracted(formattedData);
    }
  }, [response, filters]);

  const cleanFile = (details: any) => {
    const file = details?.file;

    if (!file) return "Arquivo desconhecido"; 
  
    if (typeof file === 'string') {
      if (file.includes('---file=')) {
        let fileName = file.split('---file=')[1]; 
        fileName = fileName.replace("_", " ").replace("nº", "nº ").replace(".html", "");
        return fileName;
      } else {
        return details.post_type + " nº " + details.number;
      }
    }
    return "Arquivo desconhecido";
  };

  const cleanHour = (row: any) => {
    const fileName = row.details.file;
    if (row.action === "Publicado" && row.details?.post_type) {
      const dateFile = fileName.split("date=")[1]?.split("---")[0].replace(/-/g, '');
      const dateCreated = +row.details.timestamp.slice(8, 10) + row.details.timestamp.slice(5, 7) + row.details.timestamp.slice(0, 4);
      if (dateFile<=dateCreated) {
        return row.details.timestamp.slice(11, 16);
      }
    }else if(row.action === "Publicado" && row.details?.file){
      if (fileName.includes("hour=")) {
        return fileName.split("hour=")[1].split("---")[0];
      };
    }
    else{
      const timestamp = row.details?.timestamp;
      return timestamp ? timestamp.slice(11, 16) : "Hora desconhecida";
    }   
  };

  const cleanDate = (file: string) => {
    const fileDate = formatDateUTC(file.split('T')[0]);  
    return `${fileDate}`;
  };
  return (
    <>
      <div className={styles.container}>
        <div id="searchContainer" className={styles.searchContainer}>
          <SearchHistory
            setFilters={setFilters}
            setBackup={setBackup}
            onClearFilters={handleClearFilters}
            setSearch={setIsSearched}
            />
        </div>
        <div className={styles.tableContainer}>
          <div className={styles.empty}/>
          <div id="mainTable" className={styles.mainTable}>
            <Table
              title={
                isSearched
                ? `Logs encontrados: ${
                  response.total
                }`
                : `Histórico de Logs: ${
                  response.total
                }`}
                data={extracted}
              columns={columns}
              setPage={setPage}
              page={page}
              total={
                response.total
              }
              isEmpty={response?.data?.results?.length === 0 || response.total === 0}
              loading={response.loading}
              error={response.error}
              isSearched={isSearched}
              />
          </div>
          <div className={styles.legend} id="tableLegend">
            <h3>Legenda:</h3>
            <p><span className={styles.colorGreen}></span> Publicado</p>
            <p><span className={styles.colorPurple}></span> Favoritos</p>
            <p><span className={styles.colorRed}></span> Excluído</p>
            <p><span className={styles.colorYellow}></span> Editado</p>
            <p><span className={styles.colorBlue}></span> Agendado</p>
          </div>
        </div>
      </div>
    </>
  );
}